import { BarcodeOutlined, CameraOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Modal, Row, Tooltip } from "antd";
import { useEffect } from "react";

const DeviceSelectModal = (props: {
	isMemberVisit?: any;
	isMemberRenewSelectModalVisible?: any;
	hideMemberRenewSelectModal?: any;
	showMemberRenewDeviceModal?: any;
	showMemberRenewCameraModal?: any;
}) => {
	const {
		isMemberVisit,
		isMemberRenewSelectModalVisible,
		hideMemberRenewSelectModal,
		showMemberRenewDeviceModal,
		showMemberRenewCameraModal,
	} = props;

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			// Only enable Alt+C shortcut for 来店記録 (visit record) mode
			if (isMemberVisit && isMemberRenewSelectModalVisible && event.altKey && (event.key === "c" || event.key === "C")) {
				event.preventDefault();
				showMemberRenewDeviceModal();
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [isMemberVisit, isMemberRenewSelectModalVisible, showMemberRenewDeviceModal]);

	return (
		<>
			<Modal
				title={isMemberVisit ? "来店記録" : "会員更新"}
				open={isMemberRenewSelectModalVisible}
				onCancel={hideMemberRenewSelectModal}
				footer={null}
				destroyOnClose
				centered
				styles={{
					body: {
						maxHeight: "80vh",
						overflowY: "auto",
						overflowX: "hidden",
					},
				}}
			>
				<Row justify="center" gutter={[16, 16]}>
					<Col>
						<Tooltip title={isMemberVisit ? "Alt + C" : ""}>
							<Button
								type="primary"
								size="large"
								style={{ height: "100px", width: "160px" }}
								icon={<BarcodeOutlined rev={undefined} />}
								onClick={showMemberRenewDeviceModal}
							>
								装置と手入力
							</Button>
						</Tooltip>
					</Col>

					<Col>
						<Button
							type="primary"
							size="large"
							style={{ height: "100px", width: "160px" }}
							icon={<CameraOutlined rev={undefined} />}
							onClick={showMemberRenewCameraModal}
						>
							カメラ
						</Button>
					</Col>
				</Row>
				<Divider />
				<Row justify="center">
					<Col>
						<Button
							className="px-12"
							size="large"
							onClick={hideMemberRenewSelectModal}
						>
							閉じる
						</Button>
					</Col>
				</Row>
			</Modal>
		</>
	);
};

export default DeviceSelectModal;
